import React from "react";
import { Dialog } from "@headlessui/react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

const ImageDialog = ({ open, onClose, selectedImage }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
        <Dialog.Panel className="max-h-[90vh] max-w-[90vw] overflow-hidden rounded-lg bg-white p-0">
          <div className="flex items-center justify-between border-b border-gray-300 bg-gray-100 px-4 py-2">
            <Dialog.Title className="text-lg font-semibold text-gray-800">
              Image Preview
            </Dialog.Title>
            <button
              className="text-gray-500 hover:text-gray-700"
              onClick={onClose}
            >
              ✕
            </button>
          </div>

          <div className="flex items-center justify-center bg-gray-50">
            {selectedImage ? (
              <img
                src={selectedImage}
                alt="Selected"
                className="max-h-[90vh] max-w-[90vw] object-contain"
              />
            ) : (
              <div className="flex h-full w-full items-center justify-center bg-gray-100 p-6">
                <ExclamationTriangleIcon className="h-8 w-8 text-yellow-500" />
                <p className="ml-2 text-gray-700">No image selected</p>
              </div>
            )}
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default ImageDialog;
